import { render, staticRenderFns } from "./ProductPreviewVideo.vue?vue&type=template&id=a5144d90&scoped=true&"
import script from "./ProductPreviewVideo.vue?vue&type=script&lang=js&"
export * from "./ProductPreviewVideo.vue?vue&type=script&lang=js&"
import style0 from "./ProductPreviewVideo.vue?vue&type=style&index=0&id=a5144d90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5144d90",
  null
  
)

export default component.exports